export default function InternationalPhoneFormatFun(countryCode, phoneNumber) {
    if (phoneNumber.length < 3) {
        return `NA`
    }
    if (phoneNumber.length > 15) {
        return `NaN`;
    }
    if (phoneNumber.length <= 10) {
        if (countryCode == "+91") {
            return `${countryCode} ${phoneNumber.slice(0, 5)} ${phoneNumber.slice(5)}`;
        } else {
            return `${countryCode} (${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
        }
    } else {
        return `${countryCode} ${phoneNumber.slice(0, 3)} ${phoneNumber.slice(3, 7)} ${phoneNumber.slice(7)}`;
    }
}
